import "dayjs/locale/zh-tw";
import React from "react";
import dayjs from "dayjs";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import MuiThemeBridge from "./theme/MuiThemeBridge";
import { Toaster } from "./components/ui/toaster";
import { ConfirmProvider } from "./components/modal";
import "./styles/tokens.css";
import "./styles/bundle.css";
import "./styles/bundle-extra.css";
import "./index.scss";
import RouterApp from "./Router";
import store from "./store";
import { initTheme } from "./utils/theme";
/* 頁首的字級切換已經拿掉，但登入頁與「設定 → 偏好設定」還留著，
   所以開站時仍然要把存下來的字級套回 <html>，否則那兩處設了等於沒設 */
import { initTextSize } from "./utils/textsize";

dayjs.locale("zh-tw");
initTheme();
initTextSize();

createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <MuiThemeBridge>
      <Toaster />
      <ConfirmProvider>
        <BrowserRouter>
          <RouterApp />
        </BrowserRouter>
      </ConfirmProvider>
    </MuiThemeBridge>
  </Provider>,
);
